import React from 'react';

export function CrossCircle() {
	return (
		<svg
			width="24"
			height="22"
			viewBox="0 0 24 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 21C17.5228 21 22 16.5228 22 11C22 5.47715 17.5228 1 12 1C6.47715 1 2 5.47715 2 11C2 16.5228 6.47715 21 12 21ZM15.1436 15.5578L11.9557 12.3699L8.76777 15.5578C8.5725 15.7531 8.25592 15.7531 8.06066 15.5578L7.35355 14.8507C7.15829 14.6554 7.15829 14.3389 7.35355 14.1436L10.5415 10.9557L7.35355 7.76777C7.15829 7.5725 7.15829 7.25592 7.35355 7.06066L8.06066 6.35355C8.25592 6.15829 8.5725 6.15829 8.76777 6.35355L11.9557 9.54146L15.1436 6.35355C15.3389 6.15829 15.6554 6.15829 15.8507 6.35355L16.5578 7.06066C16.7531 7.25592 16.7531 7.5725 16.5578 7.76777L13.3699 10.9557L16.5578 14.1436C16.7531 14.3389 16.7531 14.6554 16.5578 14.8507L15.8507 15.5578C15.6554 15.7531 15.3389 15.7531 15.1436 15.5578Z"
				fill="#F35843"
			/>
		</svg>
	);
}
